<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>{{'Global Map' | translate}}
        <small *ngIf="!powerMaster">
          <a [routerLink]="'/help/globalmap'" target="_blank">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </a>
        </small>
      </h1>
      <button pButton type="button" label="{{'Add' | translate}}" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="addSiteClick()" [disabled]="disableAddBtn"></button>
    </div>
    <div class="page-content main-content">
      <div class="content-area-map globalMap" style="overflow: hidden;">
        <div class="mapAlarmsInfo">
          <div class="toggle-button">
            <button (click)="toggleMapInfo()" class="btn btn-sm">
              <i class="fa {{buttonIcon}}"></i>
            </button>
          </div>
          <h3 translate>Alarms</h3>
          <p-scrollPanel [style]="{width: '100%', height: '100%'}">
            <div class="infoBox">
              <ul>
                <li>
                  <div class="list">
                    <div class="list-icon">
                      <i class="fa fa-times-circle critical" aria-hidden="true"></i>
                    </div>
                    <div class="list-info">
                      <h5 translate>Critical</h5>
                      <p>{{statusCritical.length}}</p>
                    </div>
                  </div>
                  <div class="list-detail">
                    <div class="detail">
                      <p-table [value]="statusCritical" [scrollable]="true" scrollHeight="140px">
                        <ng-template pTemplate="body" let-item>
                          <tr>
                            <td>
                              <ng-container *ngIf="item.isExpired else criticalItem">
                                {{item.name}}
                              </ng-container>
                              <ng-template #criticalItem>
                                <ng-container [ngSwitch]="item.selectType">
                                  <a *ngSwitchCase="0" routerLink="/detail/{{item.HashDeviceSN}}">{{item.name}}</a>
                                  <a *ngSwitchCase="1" routerLink="/group_detail/{{item.HashOwnerId}}">{{item.name}}</a>
                                  <a *ngSwitchCase="2" routerLink="/devicemap/edit/{{item.HashOwnerId}}">{{item.name}}</a>
                                </ng-container>
                              </ng-template>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td><div translate>No Data found</div></td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="list">
                    <div class="list-icon">
                      <i class="fa fa-exclamation-circle warning" aria-hidden="true"></i>
                    </div>
                    <div class="list-info">
                      <h5 translate>Warning</h5>
                      <p>{{statusWarning.length}}</p>
                    </div>
                  </div>
                  <div class="list-detail">
                    <div class="detail">
                      <p-table [value]="statusWarning" [scrollable]="true" scrollHeight="140px">
                        <ng-template pTemplate="body" let-item>
                          <tr>
                            <td>
                              <ng-container *ngIf="item.isExpired else warningItem">
                                {{item.name}}
                              </ng-container>
                              <ng-template #warningItem>
                                <ng-container [ngSwitch]="item.selectType">
                                  <a *ngSwitchCase="0" routerLink="/detail/{{item.HashDeviceSN}}">{{item.name}}</a>
                                  <a *ngSwitchCase="1" routerLink="/group_detail/{{item.HashOwnerId}}">{{item.name}}</a>
                                  <a *ngSwitchCase="2" routerLink="/devicemap/edit/{{item.HashOwnerId}}">{{item.name}}</a>
                                </ng-container>
                              </ng-template>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td><div translate>No Data found</div></td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="list">
                    <div class="list-icon">
                      <i class="fa fa-question-circle offline" aria-hidden="true"></i>
                    </div>
                    <div class="list-info">
                      <h5 translate>Offline</h5>
                      <p>{{statusOffline.length}}</p>
                    </div>
                  </div>
                  <div class="list-detail">
                    <div class="detail">
                      <p-table [value]="statusOffline" [scrollable]="true" scrollHeight="140px">
                        <ng-template pTemplate="body" let-item>
                          <tr>
                            <td>
                              <ng-container *ngIf="item.isExpired else offLineItem">
                                {{item.name}}
                              </ng-container>
                              <ng-template #offLineItem>
                                <ng-container [ngSwitch]="item.selectType">
                                  <a *ngSwitchCase="0" routerLink="/detail/{{item.HashDeviceSn}}">{{item.name}}</a>
                                  <a *ngSwitchCase="1" routerLink="/group_detail/{{item.HashOwnerId}}">{{item.name}}</a>
                                  <a *ngSwitchCase="2" routerLink="/devicemap/edit/{{item.HashOwnerId}}">{{item.name}}</a>
                                </ng-container>
                              </ng-template>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td><div translate>No Data found</div></td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </p-scrollPanel>
        </div>
        <div #globalmap class="map" style="width:100%;height:100%"></div>
      </div>
    </div>
  </div>
</div>

<!-- Add -->
<p-dialog header="{{dialogInput.UpdateTypeStr | translate}}" [(visible)]="displayAddSiteDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Site Name</label>
      <input type="text" size="30" class="form-control pInputText" [(ngModel)]="dialogInput.name" pInputText>
    </div>
    <div class="form-group">
      <label translate>Country</label>
      <div class="select">
        <p-select [options]="CountryOptions$ | async" [(ngModel)]="dialogInput.Country" name="Country" #country="ngModel" appendTo="body">
          <ng-template let-item pTemplate="selectedItem">
            <span>{{item.label | translate}}</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <span>{{item.label | translate}}</span>
          </ng-template>
        </p-select>
      </div>
    </div>
    <div class="form-group address">
      <div class="row coordinate">
        <div class="col-list">
          <p-radioButton value="address" inputId="locAddress" [(ngModel)]="selectLocation"></p-radioButton><label for="locAddress" translate>Address</label>
        </div>
        <div class="col-list">
          <p-radioButton value="coordinate" inputId="locCoordinate" [(ngModel)]="selectLocation"></p-radioButton><label for="locCoordinate" translate>Latitude/Longitude</label>
          <button type="button" class="btn btn-sm" (click)="op.toggle($event, targetEl)" #targetEl>
            <i class="fa fa-info-circle" aria-hidden="true"></i>
          </button>
          <!-- <p-button class="btn btn-sm" (click)="op.toggle($event, targetEl)" icon="fa fa-info-circle"></p-button> -->
          <div class="moreInfo"></div>
        </div>
      </div>
    </div>
    <p-popover #op [style]="{ 'max-width': '350px' }">
      <div class="table-responsive sec" style="margin-top: 0;">
        <div class="h5" translate>How to get Latitude and Longitude form Google Map</div>
        <ol>
          <li translate>Find the location on Google Map</li>
          <li translate>Right click the location, and click "What's here?" on the pop-out window</li>
          <li translate>The latitude and longitude will indicate below the address in another pop-out window</li>
        </ol>
      </div>
    </p-popover>
    <div class="form-group pac-container" *ngIf="selectLocation === 'address'">
      <input #locationTextField type="text" (keyup)="applyGeoInfoByAddress($event)" (blur)="applyGeoInfoByAddress($event)" [(ngModel)]="dialogInput.address" size="30" class="form-control pInputText"
             pInputText>
    </div>
    <div class="form-group" *ngIf="selectLocation === 'coordinate'">
      <div class="row coordinate">
        <div class="col-md-6">
          <input type="number" size="30" step="0.000001" [max]="89" [min]="-89"
                 onkeyup="if(parseFloat(this.value)>89){ this.value=89; return false; } if(parseFloat(this.value)<-89){ this.value=-89; return false; }" class="form-control pInputText"
                 placeholder="{{'Latitude' | translate}}" [(ngModel)]="dialogInput.latitude" (keyup)="checkLatitude($event)" (blur)="checkLatitude($event)" pInputText>
        </div>
        <div class="col-md-6">
          <input type="number" size="30" step="0.000001" [max]="180" [min]="-180"
                 onkeyup="if(parseFloat(this.value)>180){ this.value=180; return false; } if(parseFloat(this.value)<-180){ this.value=-180; return false; }" class="form-control pInputText"
                 placeholder="{{'Longitude' | translate}}" [(ngModel)]="dialogInput.longitude" (keyup)="checkLongitude($event)" (blur)="checkLongitude($event)"  pInputText>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="isMsp">
      <label translate>Company</label>
      <div class="select">
        <p-select [options]="mspCompanyOptions" [(ngModel)]="dialogInput.companySelectItem" (onChange)="mspCompanyOptionsChange()" [baseZIndex]="10000" filter="true" placeholder="Select Company" [disabled]="!isClickAdd" appendTo="body"></p-select>
      </div>
    </div>
    <div class="form-group type">
      <div class="row coordinate">
        <div class="col-list">
          <p-radioButton name="type" value="0" inputId="globalTypeDevice" [(ngModel)]="selectType"></p-radioButton><label for="globalTypeDevice" translate>Device</label>
        </div>
        <div class="col-list">
          <p-radioButton name="type" value="1" inputId="globalTypeGroup" [(ngModel)]="selectType"></p-radioButton><label for="globalTypeGroup" translate>Group</label>
        </div>
        <!-- <div class="col-list">
          <p-radioButton name="type" value="2" label="{{'Device Map' | translate}}" [(ngModel)]="selectType"></p-radioButton>
        </div> -->
      </div>
    </div>
    <div class="form-group" *ngIf="selectType == 0">
      <div class="select">
        <p-select [options]="deviceOptions$ | async" [(ngModel)]="dialogInput.selectedItem" [style]="{'width':'100%'}" placeholder="{{'Select Device' | translate}}" appendTo="body">
          <ng-template pTemplate="item" let-item>
            {{item.label | translate}}
          </ng-template>
          <ng-template pTemplate="selectedItem" let-item>
            {{item.label | translate}}
          </ng-template>
        </p-select>
      </div>
    </div>
    <div class="form-group" *ngIf="selectType == 1">
      <div class="select">
        <p-select [options]="groupOptions$ | async" [(ngModel)]="dialogInput.selectedItem" placeholder="{{'Select A Group' | translate}}" [style]="{'width':'100%'}" appendTo="body">
          <ng-template pTemplate="item" let-item>
            {{item.label | translate}}
          </ng-template>
          <ng-template pTemplate="selectedItem" let-item>
            {{item.label | translate}}
          </ng-template>
        </p-select>
      </div>
    </div>
    <div class="form-group" *ngIf="selectType == 2">
      <div class="select">
        <p-select [options]="mapOptions" [(ngModel)]="dialogInput.selectedItem" placeholder="{{'Select A Map' | translate}}" [style]="{'width':'100%'}">
        </p-select>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="deleteSite()" label="{{'Delete' | translate}}" class="{{Confirm_button}} delete" *ngIf="dialogInput.UpdateType === 2" [disabled]="disableDeleteBtn"></button>
    <button type="button" pButton (click)="addSiteSave()" label="{{'Save' | translate}}" class="{{Confirm_button}}" [disabled]="checkSiteSave()"></button>
    <button type="button" pButton (click)="displayAddSiteDialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>
<!-- <div id="infowindow-content">
  <img src="" width="16" height="16" id="place-icon" />
  <span id="place-name" class="title"></span><br />
  <span id="place-address"></span>
</div> -->

<app-dialog></app-dialog>
